<template>
<div>
    <!-- Loading state -->
    <div v-if="initilizingCart">
        <blurryLoader />
    </div>

    <!-- Processing payment popup -->
    <div v-if="submitted" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#52b2cf" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>
    <!-- Processing payment popup -->
    <div class="error_popup popup-desktop" v-if="addressError" style="display:block; z-index: 9999; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5);justify-content:center;">
        <div class="error_box error-pop-desk" style="display:flex;justify-content:center;">
            <img src="@/assets/images/icon_Urgent.svg" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">Invalid Address</div>
            <div class="text-block-1102" style="display:flex;justify-content:center;text-align: center;">FedEx and UPS our carriers do not deliver to P.O. Box addresses. Please enter a valid street address.</div>
            <div class="text-block-1102">
                <a href="#" @click.prevent="addressError=false;" class="submit-button-3 new w-button" style="color:#fff;margin-top: 0px;margin-bottom: 0px;">Update Address</a>
            </div>
        </div>
    </div>

    <!-- Logo header section -->

    <section class="section_logo-bar">
        <div class="logonav_wrap">
            <div class="logonav_div">
                <a href="#" class="link-block-73 w-inline-block"><img loading="lazy" src="@/assets/images/OhMyMeds_Logo_w.svg" alt="" class="image-487"></a>
            </div>
        </div>
    </section>

    <!-- Main checkout section -->
    <section class="checkout-section">
        <div class="checkoutb_wrap-6">
            <!-- Payment plan selection -->
            <div class="checkoutb_div">
                <div class="checkout-plans-div">
                    <div class="w-form">
                        <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" class="form-20">
                            <div class="plan-select-div checkout3">
                                <div class="select-plan-text payplan-header checkout3">1. Select Payment Plan:</div>
                                <div class="text-block-1300 checkout3">The longer you commit, <span class="text-span-290">the less you pay</span></div>
                                <div class="bullets-div">
                                    <div class="bullets-flex">
                                        <div class="bullet-point"><img loading="lazy" src="@/assets/images/icon_Dollar-blue.svg" alt="" class="image-603 _1">
                                            <div class="text-block-1533"><strong>All Doses Same Price</strong></div>
                                        </div>
                                        <div class="bullet-point"><img loading="lazy" src="@/assets/images/icon_Pricetrophy_blu.svg" alt="" class="image-603">
                                            <div class="text-block-1533"><strong>Everything Included</strong></div>
                                        </div>
                                    </div>
                                    <div class="bullets-flex">
                                        <div class="bullet-point"><img loading="lazy" src="@/assets/images/icon_savings-blue.svg" alt="" class="image-603">
                                            <div class="text-block-1533"><strong>No Membership Fees</strong></div>
                                        </div>
                                        <div class="bullet-point"><img loading="lazy" src="@/assets/images/icon_shipfast-blue.svg" alt="" class="image-603">
                                            <div class="text-block-1533"><strong>Free Shipping</strong></div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Monthly plan option -->
                                <a @click.prevent="paymentInfo.payment_terms = 1" :class="{'active-six': paymentInfo.payment_terms === 1}" href="#" class="plan-box-link w-inline-block">
                                    <div class="plan-box-div">
                                        <div class="planbox_txtdiv">
                                            <div class="div-block-2098">
                                                <div class="text-block-1437">Monthly Plan</div>
                                            </div>
                                            <div class="text-block-1440">
                                                ${{ getFirstMonthPrice().toFixed(2) }} / Month<br>
                                                3 Month supply paid monthly<br>
                                                <strong>Industry Low Pricing</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="planbox_pricebox">
                                        <div class="planbox_pricediv">
                                            <div class="text-block-1443">$</div>
                                            <div class="text-block-1438">{{ Math.floor(getFirstMonthPrice()) }}</div>
                                            <div class="text-block-1444">.{{ (getFirstMonthPrice() % 1).toFixed(2).substring(2) }}</div>
                                        </div>
                                        <div class="text-block-1439"> Per Month </div>
                                    </div>
                                </a>

                                <!-- 3-Month plan option -->
                                <a @click.prevent="paymentInfo.payment_terms = 3" :class="{'active-six': paymentInfo.payment_terms === 3}" href="#" class="plan-box-link _3mo w-inline-block">
                                    <div class="plan-box-div">
                                        <div class="planbox_txtdiv">
                                            <div class="div-block-2098">
                                                <div class="text-block-1437">3-Month Plan</div>
                                            </div>
                                            <div class="text-block-1440">${{ getMonthlyPrice(3).toFixed(2) }} / Month<br>${{ getTotalPrice(3).toFixed(2) }} Total for 3 Months<br><strong>${{ calculateSavings(3).toFixed(2) }} Total Savings</strong></div>
                                        </div>
                                    </div>
                                    <div class="planbox_pricebox">
                                        <div class="planbox_pricediv">
                                            <div>$</div>
                                            <div class="text-block-1438">{{ Math.floor(getMonthlyPrice(3)) }}</div>
                                            <div>.{{ String(Math.floor((getMonthlyPrice(3) * 100) % 100)).padStart(2, '0') }}</div>
                                        </div>
                                        <div class="text-block-1439">Monthly Avg.</div>
                                    </div>
                                </a>

                                <!-- 6-Month plan option -->
                                <a @click.prevent="paymentInfo.payment_terms = 6" :class="{'active-six': paymentInfo.payment_terms === 6}" href="#" class="plan-box-link _6mo w-inline-block">
                                    <div class="plan-box-div">
                                        <div class="planbox_txtdiv">
                                            <div class="div-block-2098">
                                                <div class="text-block-1437">6-Month Plan</div>
                                                <div class="planbox_pricebox _6mo">
                                                    <div class="planbox_pricediv">
                                                        <div>$</div>
                                                        <div class="text-block-1438">{{ Math.floor(getMonthlyPrice(6)) }}</div>
                                                        <div>.{{ String(Math.floor((getMonthlyPrice(6) * 100) % 100)).padStart(2, '0') }}</div>
                                                    </div>
                                                    <div class="text-block-1439">Monthly Avg.</div>
                                                </div>
                                            </div>
                                            <div class="text-block-1440">${{ getTotalPrice(6).toFixed(2) }} Total 6 Months<br>3 Vials Every 90 Days<br><strong>${{ calculateSavings(6).toFixed(2) }} Total Savings</strong></div>
                                        </div>
                                    </div>
                                </a>

                                <a @click.prevent="paymentInfo.payment_terms = 12" :class="{'active-six': paymentInfo.payment_terms === 12}" href="#" class="plan-box-link _6mo w-inline-block">
                                    <div class="plan-box-div">
                                        <div class="planbox_txtdiv">
                                            <div class="div-block-2098">
                                                <div class="text-block-1437">12-Month Plan</div>
                                                <div class="planbox_pricebox _6mo">
                                                    <div class="planbox_pricediv">
                                                        <div>$</div>
                                                        <div class="text-block-1438">{{ Math.floor(getMonthlyPrice(12)) }}</div>
                                                        <div>.{{ String(Math.floor((getMonthlyPrice(12) * 100) % 100)).padStart(2, '0') }}</div>
                                                    </div>
                                                    <div class="text-block-1439">Monthly Avg.</div>
                                                </div>
                                            </div>
                                            <div class="text-block-1440">${{ getTotalPrice(12).toFixed(2) }} Total 12 Months<br>3 Vials Every 90 Days<br><strong>${{ calculateSavings(12).toFixed(2) }} Total Savings</strong></div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <!-- Treatment plan review section -->
                            <div class="plan-review-div">
                                <div class="text-block-1064">2. Review Plan</div>
                                <div class="text-block-1300 checkout3">No surprises or upcharges. Same Price...All Dosages</div>

                                <!-- Monthly plan review section -->
                                <!-- Monthly plan review section - FIXED VERSION -->
                                <div class="checkout_planbox monthly" v-if="paymentInfo.payment_terms === 1" style="display:block">
                                    <div class="planbox_div1">
                                        <div class="plan_div monthly">
                                            <div class="plandetails_div">
                                                <img sizes="(max-width: 1080px) 100vw, 1080px" :srcset="getImage" alt="" :src="getImage" loading="lazy" class="image-488 _1mo">
                                                <div class="planinfo-div">
                                                    <div class="infotop">
                                                        <div class="plannameplantype info-top">
                                                            <div class="text-block-1066 myclsforse">{{ getcartItems.name }}</div>
                                                            <div class="text-block-1067">MONTHLY PLAN</div>
                                                        </div>
                                                        <div class="plandosage_div">
                                                            <div class="text-block-1068" v-if="getcartItems.name==='Tirzepatide'">Compounded w/ B6 (Pyridoxine)</div>
                                                            <div class="text-block-1068" v-else>Compounded w/ B12 (Cyanocobalamin)</div>
                                                        </div>

                                                    </div>
                                                    <div class="text-block-1070">
                                                        3-Month Supply
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="text-block-1071 myclsforse">${{ getFirstMonthPrice().toFixed(2) }}</div>
                                        </div>
                                        <div>
                                            <ul role="list" class="list-12">
                                                <li v-for="(point, index) in getPlanPoints" :key="index" class="list-item-14">
                                                    <div class="text-block-1445">{{ point.header }}</div>
                                                    <div>{{ point.sub_header }}</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="plandiscount-div" v-if="paymentInfo.discount>0">
                                            <div class="discounttype_div">
                                                <div class="text-block-1072">PROMO ${{ getMonthlyDiscount().toFixed(2) }} OFF</div>
                                            </div>
                                            <div class="dicountamount_div">
                                                <img loading="lazy" src="@/assets/images/icon_tag.svg" alt="" class="image-407">
                                                <div class="discount-text">-${{ getMonthlyDiscount().toFixed(2) }}</div>
                                            </div>
                                        </div>
                                        <div class="div-block-2102 checkout">
                                            <input class="text-field-62 coupon new w-input" v-model="couponInput" maxlength="256" name="field-3" data-name="Field 3" placeholder="Coupon Code" type="text" id="field-3" required="">
                                            <a href="#" @click.prevent="handleCouponSubmit" class="button-138 new w-button">Apply</a>
                                        </div>
                                    </div>
                                    <div class="planbox_div2">
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_board-copy.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Doctor Review &amp; Prescription</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_support.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Clinical Chat Support</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/66f29c17a6c44f05de988c80_icon_shipping.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Overnight Cold Shipping</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                    </div>
                                    <p style="font-size:8px;line-height:1;padding-top:1px;">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>
                                    <div class="planbox_div3">
                                        <div class="text-block-1076" v-if="paymentInfo.discount>0">You're Saving ${{ getMonthlyDiscount().toFixed(2) }}</div>
                                        <div class="plansubtotal_div">
                                            <div class="text-block-1075">Due Today</div>
                                            <div class="subtotalamount_div">
                                                <div class="text-block-1077">${{ getFirstMonthPrice().toFixed(2) }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-block-1442">
                                        <a href="#" @click.prevent="$router.go(-1)" class="link-75"><span class="text-span-333">&lt;- </span>Go back to Selection</a>
                                    </div>
                                    <a href="#payment-section" class="button-139 w-button">Next: Complete Payment &gt;</a>
                                </div>

                                <!-- 3-Month plan review section -->
                                <div class="checkout_planbox _3months" v-if="paymentInfo.payment_terms === 3" style="display:block">
                                    <div class="planbox_div1">
                                        <div class="plan_div monthly">
                                            <div class="plandetails_div">
                                                <img sizes="(max-width: 1080px) 100vw, 1080px" :srcset="getImage" alt="" :src="getImage" loading="lazy" class="image-488 _3months">
                                                <div class="planinfo-div">
                                                    <div class="infotop">
                                                        <div class="plannameplantype info-top">
                                                            <div class="text-block-1066 myclsforse">{{ getcartItems.name }}</div>
                                                            <div class="text-block-1067">3-MONTH PLAN</div>
                                                        </div>
                                                        <div class="plandosage_div">
                                                            <div class="text-block-1068" v-if="getcartItems.name==='Tirzepatide'">Compounded w/ B6 (Pyridoxine)</div>
                                                            <div class="text-block-1068" v-else>Compounded w/ B12 (Cyanocobalamin)</div>
                                                        </div>

                                                    </div>
                                                    <div class="text-block-1070">3-Month Supply</div>
                                                </div>
                                            </div>
                                            <div class="text-block-1071 myclsforse">${{ getTotalPrice(3).toFixed(2) }}</div>
                                        </div>
                                        <div class="plandiscount-div">
                                            <div class="discounttype_div">
                                                <div class="text-block-1072">SAVINGS</div>
                                            </div>
                                            <div class="dicountamount_div">
                                                <img loading="lazy" src="@/assets/images/icon_tag.svg" alt="" class="image-407">
                                                <div class="discount-text">${{ calculateSavings(3).toFixed(2) }}</div>
                                            </div>
                                        </div>
                                        <div class="div-block-2102 checkout">
                                            <input class="text-field-62 coupon new w-input" v-model="couponInput" maxlength="256" name="field-3" data-name="Field 3" placeholder="Coupon Code" type="text" id="field-3" required="">
                                            <a href="#" @click.prevent="handleCouponSubmit" class="button-138 new w-button">Apply</a>
                                        </div>
                                    </div>
                                    <div class="planbox_div2">
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_board-copy.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Doctor Review &amp; Prescription</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_support.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Clinical Chat Support</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>

                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/66f29c17a6c44f05de988c80_icon_shipping.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Overnight Cold Shipping</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                    </div>
                                    <p style="font-size:8px;line-height:1;padding-top:1px;">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>

                                    <div class="planbox_div3">
                                        <div class="text-block-1076">You're Saving ${{ calculateSavings(3).toFixed(2) }}</div>
                                        <div class="plansubtotal_div">
                                            <div class="text-block-1075">Due Today</div>
                                            <div class="subtotalamount_div">
                                                <div class="text-block-1077 ">${{ getTotalPrice(3).toFixed(2) }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-block-1442">
                                        <a href="#" @click.prevent="$router.go(-1)" class="link-75"><span class="text-span-333">&lt;- </span>Go back to Selection</a>
                                    </div>
                                    <a href="#payment-section" class="button-139 w-button">Next: Complete Payment &gt;</a>
                                </div>

                                <!-- 6-Month plan review section -->
                                <div class="checkout_planbox _6-months" v-if="paymentInfo.payment_terms === 6" style="display:block">
                                    <div class="planbox_div1">
                                        <div class="plan_div monthly">
                                            <div class="plandetails_div">
                                                <img sizes="(max-width: 1080px) 100vw, 1080px" :srcset="getImage" alt="" :src="getImage" loading="lazy" class="image-488 _6mo">
                                                <div class="planinfo-div">
                                                    <div class="infotop">
                                                        <div class="plannameplantype info-top">
                                                            <div class="text-block-1066 myclsforse">{{ getcartItems.name }}</div>
                                                            <div class="text-block-1067">6-MONTH PLAN</div>
                                                        </div>
                                                        <div class="plandosage_div">
                                                            <div class="text-block-1068" v-if="getcartItems.name==='Tirzepatide'">Compounded w/ B6 (Pyridoxine)</div>
                                                            <div class="text-block-1068" v-else>Compounded w/ B12 (Cyanocobalamin)</div>
                                                        </div>
                                                    </div>
                                                    <div class="text-block-1070">6-Month Supply </div>
                                                </div>
                                            </div>
                                            <div class="text-block-1071 myclsforse">${{ getTotalPrice(6).toFixed(2) }}</div>
                                        </div>
                                        <div class="text-block-1446">3 month supply now, 3 more in 90 days.</div>
                                        <div class="plandiscount-div">
                                            <div class="discounttype_div">
                                                <div class="text-block-1072">SAVINGS</div>
                                            </div>
                                            <div class="dicountamount_div">
                                                <img loading="lazy" src="@/assets/images/icon_tag.svg" alt="" class="image-407">
                                                <div class="discount-text">${{ calculateSavings(6).toFixed(2) }}</div>
                                            </div>
                                        </div>
                                        <div class="div-block-2102 checkout">
                                            <input class="text-field-62 coupon new w-input" v-model="couponInput" maxlength="256" name="field-3" data-name="Field 3" placeholder="Coupon Code" type="text" id="field-3" required="">
                                            <a href="#" @click.prevent="handleCouponSubmit" class="button-138 new w-button">Apply</a>
                                        </div>
                                    </div>
                                    <div class="planbox_div2">
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_board-copy.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Doctor Review &amp; Prescription</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_support.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Clinical Chat Support</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>

                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/66f29c17a6c44f05de988c80_icon_shipping.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Overnight Cold Shipping</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                    </div>
                                    <p style="font-size:8px;line-height:1;padding-top:1px;">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>

                                    <div class="planbox_div3">
                                        <div class="text-block-1076">You're Saving ${{ calculateSavings(6).toFixed(2) }}</div>
                                        <div class="plansubtotal_div">
                                            <div class="text-block-1075">Due Today</div>
                                            <div class="subtotalamount_div">
                                                <div class="text-block-1077">${{ getTotalPrice(6).toFixed(2) }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-block-1442">
                                        <a href="#" @click.prevent="$router.go(-1)" class="link-75"><span class="text-span-333">&lt;- </span>Go back to Selection</a>
                                    </div>
                                    <a href="#payment-section" class="button-139 w-button">Next: Complete Payment &gt;</a>
                                </div>

                                <div class="checkout_planbox _6-months" v-if="paymentInfo.payment_terms === 12" style="display:block">
                                    <div class="planbox_div1">
                                        <div class="plan_div monthly">
                                            <div class="plandetails_div">
                                                <img sizes="(max-width: 1080px) 100vw, 1080px" :srcset="getImage" alt="" :src="getImage" loading="lazy" class="image-488 _6mo">
                                                <div class="planinfo-div">
                                                    <div class="infotop">
                                                        <div class="plannameplantype info-top">
                                                            <div class="text-block-1066 myclsforse">{{ getcartItems.name }}</div>
                                                            <div class="text-block-1067">12-MONTH PLAN</div>
                                                        </div>
                                                        <div class="plandosage_div">
                                                            <div class="text-block-1068" v-if="getcartItems.name==='Tirzepatide'">Compounded w/ B6 (Pyridoxine)</div>
                                                            <div class="text-block-1068" v-else>Compounded w/ B12 (Cyanocobalamin)</div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="text-block-1071 myclsforse">${{ getTotalPrice(12).toFixed(2) }}</div>
                                        </div>
                                        <div class="text-block-1446">3 Vials Every 90 Days for a Year.</div>
                                        <div class="plandiscount-div">
                                            <div class="discounttype_div">
                                                <div class="text-block-1072">SAVINGS</div>
                                            </div>
                                            <div class="dicountamount_div">
                                                <img loading="lazy" src="@/assets/images/icon_tag.svg" alt="" class="image-407">
                                                <div class="discount-text">${{ calculateSavings(12).toFixed(2) }}</div>
                                            </div>
                                        </div>
                                        <div class="div-block-2102 checkout">
                                            <input class="text-field-62 coupon new w-input" v-model="couponInput" maxlength="256" name="field-3" data-name="Field 3" placeholder="Coupon Code" type="text" id="field-3" required="">
                                            <a href="#" @click.prevent="handleCouponSubmit" class="button-138 new w-button">Apply</a>
                                        </div>
                                    </div>
                                    <div class="planbox_div2">
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_board-copy.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Doctor Review &amp; Prescription</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/icon_support.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Clinical Chat Support</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>

                                        <div class="freebie_div">
                                            <div class="freebietypediv">
                                                <img loading="lazy" src="@/assets/images/66f29c17a6c44f05de988c80_icon_shipping.svg" alt="" class="image-491">
                                                <div class="text-block-1073">Overnight Cold Shipping</div>
                                            </div>
                                            <div class="discount-text free">INCLUDED</div>
                                        </div>
                                    </div>
                                    <p style="font-size:8px;line-height:1;padding-top:1px;">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>

                                    <div class="planbox_div3">
                                        <div class="text-block-1076">You're Saving ${{ calculateSavings(12).toFixed(2) }}</div>
                                        <div class="plansubtotal_div">
                                            <div class="text-block-1075">Due Today</div>
                                            <div class="subtotalamount_div">
                                                <div class="text-block-1077">${{ getTotalPrice(12).toFixed(2) }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-block-1442">
                                        <a href="#" @click.prevent="$router.go(-1)" class="link-75"><span class="text-span-333">&lt;- </span>Go back to Selection</a>
                                    </div>
                                    <a href="#payment-section" class="button-139 w-button">Next: Complete Payment &gt;</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Payment section -->
            <div id="payment-section" class="checkoutb_div">
                <div class="text-block-1064">3. Complete Payment</div>
                <div class="text-block-1300 checkout3">Lock in industry low pricing. Instant Refund if not approved.</div>
                <div class="trust-pilot-div checkout">
                    <a href="https://www.trustpilot.com/review/ohmymeds.com" target="_blank" class="link-block-89 w-inline-block animateatag">
                        <div class="text-block-1532">Excellent</div><img src="@/assets/images/trustpilot-rating.png" loading="lazy" sizes="(max-width: 785px) 100vw, 785px" srcset="@/assets/images/trustpilot-rating-p-500.png 500w, @/assets/images/trustpilot-rating.png 785w" alt="" class="image-610">
                        <div class="text-block-1531">4.9 out of 5</div><img src="@/assets/images/Trustpilot_Logo_2022.svg.png" loading="lazy" sizes="(max-width: 2560px) 100vw, 2560px" srcset="@/assets/images/Trustpilot_Logo_2022.svg-p-500.png 500w, @/assets/images/Trustpilot_Logo_2022.svg-p-800.png 800w, @/assets/images/Trustpilot_Logo_2022.svg-p-1080.png 1080w, @/assets/images/Trustpilot_Logo_2022.svg-p-1600.png 1600w, images/Trustpilot_Logo_2022.svg-p-2000.png 2000w, @/assets/images/Trustpilot_Logo_2022.svg.png 2560w" alt="" class="image-611">
                    </a>
                </div>
                <div class="div-block-2100">
                    <div class="form-block-18 w-form">
                        <form id="email-form-3" name="email-form-3" data-name="Email Form 3" method="get">
                            <div class="checkout-3_-card-payment-div">

                                <!-- Payment method section -->
                                <div class="div-block-853 new">
                                    <div class="text-block-80"><strong class="bold-text-4">Credit Card</strong></div>
                                    <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103790_visa.png" class="image-471">
                                    <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103780_mastercard.png" class="image-471">
                                    <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103794_AmEx.png" class="image-471">
                                    <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd3610377e_discover.png" class="image-471">
                                </div>

                                <!-- Card input -->
                                <div>
                                    <label for="email" class="field-label-4 new">Card Number</label>
                                    <div id="card-element" class="text-field-7 new w-input" ref="myElement"></div>
                                </div>

                                <label for="email" class="field-label-4">Shipping Address</label>
                                <div class="">
                                    <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressData" class="" />

                                </div>
                                <label class="w-checkbox checkbox-field-23">
                                    <input type="checkbox" name="checkbox-3" id="checkbox-3" @change="differentShipping = !differentShipping" data-name="Checkbox 3" class="w-checkbox-input">
                                    <span class="checkbox-label-23 w-form-label" for="checkbox-3">Different Billing Address?</span>
                                </label>

                                <!-- Billing address section (conditional) -->
                                <div v-if="differentShipping">
                                    <label for="email" class="field-label-4">Billing Address</label>
                                    <div class="">
                                        <div class="">
                                            <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressDataBilling" class="" />
                                        </div>
                                    </div>
                                </div>

                                <!-- Error message display -->
                                <div v-if="paymentError" class="w-form-fail" style="display:block;">
                                    <div>{{ errorMessage }}</div>
                                </div>
                                
                                <!-- Submit button -->
                                <input type="submit" @click.prevent="getStripeToken" data-wait="Please wait..." class="submit-button-3 new w-button" value="BUY NOW">

                                <!-- Disclaimer -->
                                <div class="div-block-1154">
                                    <input type="hidden" name="xxTrustedFormCertUrl" id="xxTrustedFormCertUrl_0" ref="trustedFormUrl" value="">
                                    <p class="disclaimer-paragraph">
                                        By clicking "Buy Now and Save" or checking out with Apple or Google Pay you agree to enroll in a {{ paymentInfo.payment_terms }}-month program billed {{ getBillingFrequency() }}, with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the <a href="https://ohmymeds.com/returns" target="_blank" class="disc-link">Refund Policy</a>, <a href="https://ohmymeds.com/terms" target="_blank" class="disc-link">Terms and Conditions</a>, <a href="https://ohmymeds.com/terms" target="_blank" class="disc-link">Terms of Use</a>, <a href="https://ohmymeds.com/privacy" target="_blank" class="disc-link">Privacy Policy</a>, <a href="https://ohmymeds.com/hipaa" target="_blank" class="disc-link">HIPAA Notice</a>, and <a href="https://ohmymeds.com/telehealth" target="_blank" class="disc-link">Telehealth Consent</a>, and are at least 18 years of age.
                                    </p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import {
    BasisTheory
} from "@basis-theory/basis-theory-js";
import detectMobile from '@/utils/MobileDetection.js';
import GooglePlacesAutocomplete from '../common/GooglePlacesAutocomplete.vue';
import blurryLoader from '../common/blurryLoader.vue';
import {
    mapActions,
    mapGetters
} from 'vuex';

// Initialize BasisTheory instance
let bt;
async function initBasisTheory() {
    try {
        bt = await new BasisTheory().init(process.env.VUE_APP_BASIS, {
            elements: true
        });
    } catch (error) {
        console.error('Failed to initialize BasisTheory:', error);
    }
}

export default {
    name: 'CheckoutComponent',
    components: {
        GooglePlacesAutocomplete,
        blurryLoader,
    },
    props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
    data() {
        return {
            nofunds: 0,
            paymentAttempts: 0,
            updateKey: 1,
            maxPaymentAttempts: 3,
            appName: process.env.VUE_APP_COMPANY || 'OhMyMeds',
            appMainWeb: process.env.VUE_APP_HOMEPAGE || 'https://ohmymeds.com',
            assetPath: '/images', // Path to your assets/images
            payment_open: 0,
            addressError: false,
            paymentError: false,
            errorMessage: '',
            initilizingCart: true,
            cartError: false,
            isApplePaySupported: false,
            isGooglePaySupported: false,
            differentShipping: false,
            couponValid: true,
            couponError: false,
            couponApplied: false,
            submitted: false,
            trustUrl: '',
            couponInput: '',
            ip_address: '',
            message: '',
            offer: '',
            termsAccepted: true,
            cardExpiry: '',
            cardCvv: '',
            cardElement: null,
            defaultProduct: null,
            phone: {
                area: '',
                prefix: '',
                line: ''
            },
            customerInfo: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            billingAddress: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            paymentInfo: {
                payment_terms: 6, // Default to monthly plan
                user_id: '',
                cardToken: '',
                amount: 249.97, // Default amount for first month
                discount: 0,
                medication: '',
                couponCode: '',
                drug_mode: '',
                couponId: null,
                paymentMethod: null,
                cartItems: [],
                cardDetails: [],
                planId: '',
            },
            // Centralized configuration for pricing - easier to maintain
            pricingConfig: {
                semaglutide: {
                    monthly: {
                        first: 249.99,
                        regular: 249.99
                    },
                    terms: {
                        3: 449.99,
                        6: 809.99,
                        12: 1279.99
                    }
                },
                tirzepatide: {
                    monthly: {
                        first: 349.99,
                        regular: 349.99
                    },
                    terms: {
                        3: 749.99,
                        6: 1349.99,
                        12: 2349.00
                    }
                }
            },
            // Centralized labels for payment terms - easier to maintain
            paymentTermLabels: {
                1: {
                    planName: "Monthly Plan",
                    duration: "monthly",
                    billingFrequency: "monthly",
                    billingLabel: "Billed Monthly",
                    supplyDuration: "Monthly"
                },
                3: {
                    planName: "Quarterly Plan",
                    duration: "3-month",
                    billingFrequency: "quarterly",
                    billingLabel: "Billed Quarterly",
                    supplyDuration: "3 Month"
                },
                6: {
                    planName: "Half Yearly Plan",
                    duration: "6-month",
                    billingFrequency: "every 6 months",
                    billingLabel: "Billed Every 6 Months",
                    supplyDuration: "6 Month"
                },
                12: {
                    planName: "Yearly Plan",
                    duration: "12-month",
                    billingFrequency: "annually",
                    billingLabel: "Billed Annually",
                    supplyDuration: "12 Month"
                }
            },
        };
    },

    async mounted() {
        await initBasisTheory();
        await this.checkAuthAndInitialize();
        this.getIpAddress();
    },

    created() {
        // Set default product if not available
        this.defaultProduct = {
            name: 'Tirzepatide',
            quantity: 1,
            image: 'https://ohmymeds.s3.us-east-2.amazonaws.com/public/assets/product_image/webp/tirzepatide/1.webp',
            category: "Weight",
            id: "675ac4cb6bf102c19ec3afec",
            main_type: 1,
            price: 249.97,
            retail_price: 249.97,
            stripe_id: 'tirz_plan_1',
            sku: '23_1',
            subheader: "Compound Medication"
        };

    },

    watch: {
        isMobile: {
            immediate: true,
            handler(newVal) {
                console.log('Mobile view:', newVal);
            }
        },
        'paymentInfo.payment_terms'() {
            this.couponInput = "";
            this.paymentInfo.couponId = null;
            this.couponApplied = false;
            this.paymentInfo.discount = 0;
        }
    },

    methods: {
        ...mapActions([
            'setCartVisibility',
            'clearCart',
            'addToCart',
            'doLogin',
            'setPrescriptionPreauths',
            'addSemaOffer',
            'addTirOffer'
        ]),

        // PRICING METHODS - Centralized pricing logic for easier maintenance
        getProductPricing() {
            const productName = this.getcartItems?.name || 'Tirzepatide';
            return productName === 'Semaglutide' ?
                this.pricingConfig.semaglutide :
                this.pricingConfig.tirzepatide;
        },

        getFirstMonthPrice() {
            return this.getProductPricing().monthly.first - this.paymentInfo.discount;
        },

        getRegularMonthlyPrice() {
            return this.getProductPricing().monthly.regular;
        },

        getMonthlyDiscount() {
            return this.getRegularMonthlyPrice() - this.getFirstMonthPrice();
        },

        getTotalPrice(term) {
            return this.getProductPricing().terms[term] - this.paymentInfo.discount;
        },

        getMonthlyPrice(term) {
            return this.getTotalPrice(term) / term;
        },

        getCurrentPrice() {
            if (this.paymentInfo.payment_terms === 1) {
                return this.getFirstMonthPrice();
            } else {
                return this.getTotalPrice(this.paymentInfo.payment_terms);
            }
        },

        // Calculate the total savings compared to monthly pricing
        calculateSavings(term) {
            const monthlyPlanTotal = this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (term - 1));
            const prepaidTotal = this.getTotalPrice(term);
            return monthlyPlanTotal - (prepaidTotal - this.paymentInfo.discount);
        },

        // Get the billing frequency text based on selected term
        getBillingFrequency() {
            return this.paymentTermLabels[this.paymentInfo.payment_terms].billingFrequency;
        },

        async changeItem(currentName) {
            try {
                // Reset states
                this.couponInput = "";
                this.paymentInfo.couponId = null;
                this.couponApplied = false;
                this.paymentInfo.discount = 0;
                this.paymentError = false;
                this.submitted = false;

                // Create new item with appropriate pricing based on medication type
                const newItem = {
                    name: currentName === 'Semaglutide' ? 'Tirzepatide' : 'Semaglutide',
                    quantity: 1,
                    image: currentName === 'Semaglutide' ?
                        'https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/tirzepatide/1.webp' : 'https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/semaglutide/1.webp',
                    category: "Weight",
                    id: currentName === 'Semaglutide' ? "675ac4cb6bf102c19ec3afec" : "675ac4cb6bf102c19ec3afe9",
                    main_type: 1,
                    price: currentName === 'Semaglutide' ?
                        this.pricingConfig.tirzepatide.monthly.first : this.pricingConfig.semaglutide.monthly.first,
                    retail_price: currentName === 'Semaglutide' ?
                        this.pricingConfig.tirzepatide.monthly.regular : this.pricingConfig.semaglutide.monthly.regular,
                    stripe_id: currentName === 'Semaglutide' ? 'tirz_plan_1' : 'sema_plan_278928',
                    kku: currentName === 'Semaglutide' ? '23_1' : "24",
                    subheader: "Compound Medication"
                };

                // Update cart
                await this.clearCart();
                await this.addToCart(newItem);
                this.setCartVisibility(false);
                window.location.reload();

                // Reset payment integrations

                if (this.cardElement) {
                    this.cardElement.clear();
                }
            } catch (error) {
                console.error('Error switching medication:', error);
                this.paymentError = true;
                this.errorMessage = "Error switching medication. Please try again.";
            }
        },

        showChatWindow() {
            this.$emit("showChatWindow");
        },
        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },
        getPhoneNumber() {
            return `${this.phone.area}-${this.phone.prefix}-${this.phone.line}`;
        },

        async handleCouponSubmit() {
            this.errorMessage = null;
            if (!this.couponInput) {
                this.errorMessage = 'Please enter a coupon code';
                return;
            }
            this.paymentInfo.couponCode = this.couponInput;
            await this.validateCoupon();
        },

        async validateCoupon() {
            if (this.couponApplied) return;
            this.couponError = false;
            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                    coupon: this.paymentInfo.couponCode,
                    payment_terms: this.paymentInfo.payment_terms
                });

                if (response.data.status === 'success') {
                    this.couponValid = true;
                    this.couponApplied = true;
                    this.paymentInfo.couponId = response.data.coupon_id;
                    this.paymentInfo.discount = response.data.c_val;
                } else {
                    this.couponValid = false;
                    this.couponError = true;
                }
            } catch (error) {
                this.couponValid = false;
                this.couponError = true;
            }
        },

        checkAuthAndInitialize() {
            if (!this.isLoggedin) {
                // If cart_id is available in route params, try to fetch cart data
                if (this.$route.params.cart_id) {
                    this.$axios.get(`${this.baseUrl}/api/get-cart/${this.$route.params.cart_id}`, {
                            headers: {
                                'Content-Type': 'application/json',
                            }
                        }).then(response => {
                            if (response.data.status === 'success') {
                                let cartItem = response.data.cartItem;
                                try {
                                    let keyToDelete = "sema_offer";
                                    if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                                        this.addSemaOffer(cartItem[keyToDelete]);
                                        delete cartItem[keyToDelete];
                                    }
                                    keyToDelete = "tir_offer";
                                    if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                                        this.addTirOffer(cartItem[keyToDelete]);
                                        delete cartItem[keyToDelete];
                                    }
                                } catch (error) {
                                    console.log(error.message)
                                }

                                this.doLogin(response.data.userData);
                                this.addToCart(cartItem);
                                this.setCartVisibility(false);
                                window.location.reload();

                            } else {
                                this.initilizingCart = false;
                                this.message = response.data.message;
                                this.cartError = true;
                                console.error("Unexpected response:", response.data);
                            }
                        })
                        .catch(error => {
                            console.error("Error saving cart:", error);
                            this.initilizingCart = false;
                            this.message = `${error.message}. Please check the checkout link is correct.`
                            this.cartError = true;
                        });
                } else {
                    // No cart_id, use default product
                    this.initilizingCart = false;
                    this.createCardElement();

                }
            } else {
                this.initilizingCart = false;
                this.createCardElement();

            }
        },

        createCardElement() {
            try {
                if (bt && bt.createElement) {
                    this.cardElement = bt.createElement('card');
                    this.cardElement.mount('#card-element');
                } else {
                    console.error('BasisTheory instance not properly initialized');
                    // Try to reinitialize
                    initBasisTheory().then(() => {
                        this.cardElement = bt.createElement('card');
                        this.cardElement.mount('#card-element');
                    }).catch(error => {
                        console.error('Failed to initialize BasisTheory:', error);
                    });
                }
            } catch (error) {
                console.error('Error creating card element:', error);
            }
        },
        isPOBox(address) {
            const normalized = address.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
            const poBoxRegex = /\b(po box|post office box|p o box)\b(?:\s*\d{0,6})?/i;
            return poBoxRegex.test(normalized);
        },
        getAddressData(address) {
            if (this.isPOBox(address.street)) {
                this.addressError = true;
                this.customerInfo.addressLine2 = address.address_line2;
                this.customerInfo.city = address.city;
                this.customerInfo.state = address.state;
                this.customerInfo.zip = address.zip;
            } else {
                this.addressError = false;
                this.customerInfo.addressLine1 = address.street;
                this.customerInfo.addressLine2 = address.address_line2;
                this.customerInfo.city = address.city;
                this.customerInfo.state = address.state;
                this.customerInfo.zip = address.zip;
                this.updateAddress();
            }
        },

        getAddressDataBilling(address) {
            this.billingAddress.addressLine1 = address.street;
            this.billingAddress.addressLine2 = address.address_line2;
            this.billingAddress.city = address.city;
            this.billingAddress.state = address.state;
            this.billingAddress.zip = address.zip;
        },

        async updateAddress() {
            try {
                this.customerInfo.id = this.user?.id || 'guest-' + Date.now();
                await this.$axios.post(`${this.baseUrl}/api/save-address`, this.customerInfo);
            } catch (error) {
                console.error('Error updating address:', error);
                // Don't throw error here, as it might block payment flow
            }
        },

        validateAddress(address) {
            return address.addressLine1 &&
                address.city &&
                address.state &&
                address.zip;
        },

        getStripeToken() {
            this.submitted = true;
            this.paymentError = false;
            console.log("submitting")
            // Validate shipping address
            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a complete shipping address.";
                this.submitted = false;
                return false;
            }

            // Validate billing address if different
            if (this.differentShipping && !this.validateAddress(this.billingAddress)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a complete billing address.";
                this.submitted = false;
                return false;
            }

            // Check terms accepted
            if (!this.termsAccepted) {
                this.paymentError = true;
                this.errorMessage = "Please agree to the terms and conditions.";
                this.submitted = false;
                return false;
            }

            this.errorReason = false;

            // Create token with BasisTheory
            if (bt && bt.tokens) {
                bt.tokens
                    .create({
                        type: "card",
                        data: this.cardElement,
                    })
                    .then((token) => {
                        this.paymentInfo.cardToken = token.id;
                        this.paymentInfo.cardDetails = token.data;
                        this.paymentInfo.paymentMethod = 'card';
                        console.log("token received")
                        this.processPayment();
                    })
                    .catch((error) => {
                        console.log(error);
                        this.paymentError = true;
                        this.errorMessage = "Invalid card details";
                        this.submitted = false;
                    });
            } else {
                // BasisTheory not initialized correctly
                console.error('BasisTheory not initialized');
                this.paymentError = true;
                this.errorMessage = "Payment system not initialized. Please refresh the page and try again.";
                this.submitted = false;

                // Try to reinitialize
                initBasisTheory()
                    .then(() => {
                        this.createCardElement();
                        this.paymentError = true;
                        this.errorMessage = "Payment system reinitialized. Please try again.";
                        this.submitted = false;
                    })
                    .catch(error => {
                        console.error('Failed to reinitialize BasisTheory:', error);
                    });
            }
        },

        async sendRequest(paymentData) {
            let response = await this.$axios.post(`${this.baseUrl}/api/checkout-new`, paymentData);
            return response;
        },

        async processPayment() {
            try {
                    this.trustUrl = this.$refs.trustedFormUrl.value;
                } catch (error) {
                    console.log("no trust form found")
                }

            if (this.nofunds > 3) {
                this.paymentError = true;
                this.errorMessage = "Card Temporarily Blocked : Your card has been declined 3 times and is now temporarily blocked for 24 hours. Please check your card details or contact your bank. You'll be able to try again after the 24-hour period."
                this.blockCart();
                return false;
            }
            try {
                localStorage.setItem("productName", JSON.stringify(this.getcartItems.name))
            } catch (e) {
                console.log(e)
            }
            console.log("processing payment")
            try {
                // Check required fields for mobile view
                if (this.isMobile) {

                    if (!this.termsAccepted) {
                        this.paymentError = true;
                        this.errorMessage = "Please agree to the terms and conditions.";
                        this.submitted = false;
                        return;
                    }
                }

                this.submitted = true;
                this.paymentError = false;

                // Get user ID from store or use a placeholder for guest checkout
                this.paymentInfo.user_id = this.user?.id || 'guest-' + Date.now();
                this.paymentInfo.id = this.paymentInfo.user_id;
                this.paymentInfo.cartItems = this.cartItems.length > 0 ? this.cartItems : [this.defaultProduct];
                this.paymentInfo.planId = this.getOfferName;

                // If using mobile view, add phone number
                if (this.isMobile) {
                    this.paymentInfo.phone = this.getPhoneNumber();
                }

                let paymentData = {
                    ...this.paymentInfo,
                    amount: this.amountInCents,
                    cartTotal: this.cartTotal || this.getCurrentPrice(),
                    cartTotalNoDiscount: this.cartTotalNoDiscount || this.getCurrentPrice(),
                    offer: this.offer,
                    billingAddress: this.customerInfo,
                    shippingAddress: this.customerInfo,
                    user_agent: window.navigator.userAgent,
                    ip_address: this.ip_address,
                    tracking_session_id: window.trackingSessionId
                };

                if (this.differentShipping) {
                    paymentData = {
                        ...this.paymentInfo,
                        billingAddress: this.billingAddress,
                        shippingAddress: this.customerInfo,
                        amount: this.amountInCents,
                        cartTotal: this.cartTotal || this.getCurrentPrice(),
                        cartTotalNoDiscount: this.cartTotalNoDiscount || this.getCurrentPrice(),
                        offer: this.offer,
                    };
                }

                const response = await this.sendRequest(paymentData);
                let amountCharged = ((paymentData.amount / 100) - paymentData.discount)
                if (response.data.status === 'success') {

                    await this.saveTrustFrom(this.trustUrl);
                    await this.updateAddress();
                    await this.clearCart();

                    let transactionIdentifier;
                    try {
                        if (response.data.transaction_id) {
                            transactionIdentifier = response.data.transaction_id;
                        } else if (response.data.prescriptionPreauths && response.data.prescriptionPreauths.length > 0) {
                            transactionIdentifier = response.data.prescriptionPreauths[0].transactionId;
                        } else {
                            // Final fallback: customer ID + timestamp for unique identifier
                            transactionIdentifier = `${response.data.customerId}_${Date.now()}`;
                        }
                    } catch (e) {
                        console.log(e)
                        transactionIdentifier = `${Date.now()}`;
                    }

                    this.pushToRoute(amountCharged, transactionIdentifier);
                    await this.setPrescriptionPreauths(response.data.prescriptionPreauths);
                    this.submitted = false;
                } else {
                    this.paymentError = true;
                    this.errorMessage = "Uh oh! It looks like your card was declined. No worries—your bank might have sent you a text to approve the charge. Just reply to their message to approve it and try again, or feel free to use a different card.";
                    this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                const errorMessage = error.response?.data?.message || "";

                // Check for blocking message from backend
                if (errorMessage.toLowerCase().includes("3 attempts") || errorMessage.toLowerCase().includes("unable to process your card after")) {
                    this.errorMessage = errorMessage; // Use the exact backend message
                    this.submitted = false;
                    return;
                }

                // Increment payment attempts
                this.paymentAttempts++;

                // Check if frontend has exceeded max attempts
                if (this.paymentAttempts >= this.maxPaymentAttempts) {
                    this.errorMessage = `You've tried this card multiple times without success. Please use a different card to complete your purchase. Error: ${errorMessage}`;
                    this.submitted = false;
                    return;
                }

                // Check for specific error cases
                if (errorMessage === "An active order exists on your account. Please login to your account to view or modify it.") {
                    this.errorMessage = errorMessage;
                } else if (errorMessage.toLowerCase().includes("insufficient")) {
                    this.errorMessage = "It looks like your card has insufficient funds. Please use a different payment method or contact your bank for assistance.";
                } else if (errorMessage.toLowerCase().includes("cvv") || errorMessage.toLowerCase().includes("security code")) {
                    this.errorMessage = "The CVV/security code you entered doesn't match your card. Please double-check the 3-4 digit code on the back of your card and try again.";
                } else if (errorMessage.toLowerCase().includes("avs") || errorMessage.toLowerCase().includes("address") || errorMessage.toLowerCase().includes("billing")) {
                    this.errorMessage = "The billing address you entered doesn't match what your bank has on file. Please verify your address details and try again.";
                } else {
                    // Default decline message
                    this.errorMessage = "Uh oh! It looks like your card was declined. No worries—your bank might have sent you a text to approve the charge. Just reply to their message to approve it and try again, or feel free to use a different card.";
                }

                this.submitted = false;
            }

        },
        blockCart() {
            this.$axios.get(`${this.baseUrl}/api/block-user-payment`);
        },
        saveTrustFrom(url) {
            try {
                this.$axios.post(`${this.baseUrl}/api/trust-form`, {
                    "user_id": this.user.id,
                    "url": url
                });
            } catch (error) {
                console.log("error saving url trust");
            }
        },

        pushToRoute(amountCharged, transaction_id) {
            try {
                const query = {};
                if (this.paymentInfo.payment_terms !== null) {
                    query.terms = String(this.paymentInfo.payment_terms);
                }
                query.amount = amountCharged;
                query.trans_id = transaction_id;
                this.$router.push({
                    name: 'prescriptionThanks',
                    query
                });
            } catch (error) {
                console.log(error);
                this.$router.push({
                    name: 'prescriptionThanks'
                });
            }
        },
        // Calculate and format savings text for display
        getSavingsText(value) {
            const monthlyPlanTotal = this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (value - 1));
            const prepaidTotal = this.getTotalPrice(value);
            const savings = monthlyPlanTotal - prepaidTotal;
            return `${savings.toFixed(2)} Total Savings`;
        },
    },

    computed: {
        ...mapGetters([
            'user',
            'cartItems',
            'cartTotal',
            'cartDiscount',
            'cartTotalNoDiscount',
            'isAuthenticated',
            'offerSema',
            'offerTir'
        ]),

        getPlanPoints() {
            if (this.paymentInfo.payment_terms >= 3) {
                const monthlyPlanTotal = this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (this.paymentInfo.payment_terms - 1));
                const prepaidTotal = this.getTotalPrice(this.paymentInfo.payment_terms);
                const savings = monthlyPlanTotal - prepaidTotal;
                const savingsPercent = ((savings / monthlyPlanTotal) * 100).toFixed(0);

                return [{
                        "header": `${(savings / this.paymentInfo.payment_terms).toFixed(0)} a month savings!`,
                        "sub_header": `You will save ${(savings / this.paymentInfo.payment_terms).toFixed(0)} a month paying for ${this.paymentInfo.payment_terms} months up front (${savings.toFixed(0)} Total Savings) vs. our monthly installment plan.`
                    },
                    {
                        "header": `Save up to ${savingsPercent}%`,
                        "sub_header": `You will save big by paying for our ${this.paymentInfo.payment_terms} month program up front.`
                    },
                    {
                        "header": `${this.paymentInfo.payment_terms} Month Supply Program`,
                        "sub_header": `You'll receive a ${this.paymentInfo.payment_terms}-month supply of medication, billed ${this.getBillingFrequency()}. If you cancel before completing the full term, an early termination fee may apply.`
                    }
                ];
            }

            // Monthly plan points
            return [{
                "header": `${this.getRegularMonthlyPrice().toFixed(2)} per month`,
                "sub_header": `Paid monthly with 3 month commitment. We send 3 month's worth of medication up front. Zero interest. No credit checks. All dosages.`
            }];
        },

        getOfferName() {
            let offer = this.offerTir;
            if (this.getcartItems && this.getcartItems.name === 'Semaglutide') {
                offer = this.offerSema;
            }
            return offer;
        },

        getSupplyDuration() {
            return this.paymentTermLabels[this.paymentInfo.payment_terms].supplyDuration;
        },

        getImage() {
            return this.getcartItems?.image || `${this.assetPath}/1.webp`;
        },

        getcartItems() {
            return this.cartItems && this.cartItems.length > 0 ?
                this.cartItems[0] :
                this.defaultProduct;
        },

        isMobile() {
            return detectMobile();
        },

        isLoggedin() {
            return this.isAuthenticated;
        },

        amountInCents() {
            return Math.round(this.getCurrentPrice() * 100);
        },

        finalTotal() {
            if (this.couponApplied) {
                return this.cartTotalNoDiscount - this.paymentInfo.discount;
            }
            return this.cartTotal;
        },

        getDiscount() {
            if (this.couponApplied) {
                return this.paymentInfo.discount;
            }
            return this.cartDiscount;
        }
    }
}
</script>

<style scoped>
.active-six {
    color: #fff;
    background-color: var(--blue);
    border: 1px solid var(--blue);

}

.myspanret {
    font-weight: bold;
    font-size: 22px;
}

@media screen and (max-width: 479px) {
    .text-field-58.new {
        color: #000;
        height: 48px;
    }

    .text-field-7.new {
        color: #000;
        height: 48px;
    }
}

@media screen and (max-width: 479px) {
    .myclsforse {
        font-size: 20px;
    }
}

.animateatag {
    opacity: 1;
    transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
    transform-style: preserve-3d;
}

.noshowani {
    opacity: 0;
}
</style>
